import { Tool } from '../../types';

export const collaborationTools: Tool[] = [
  {
    id: 'notion',
    name: 'Notion',
    category: 'Collaboration',
    description: 'All-in-one workspace for notes, docs, and collaboration',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['startup', 'small-business', 'freelancer'],
    compatibleWith: ['agency', 'content-creator', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'creative', 'marketing'],
    website: 'https://affiliate.notion.so/bsptyvf8xo2o',
    imageUrl: 'https://logo.clearbit.com/notion.so',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'confluence',
    name: 'Confluence',
    category: 'Collaboration',
    description: 'Team collaboration and documentation platform',
    pricing: ['low', 'medium'],
    features: ['integrations', 'mobile', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'agency', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing', 'consulting'],
    website: 'https://www.atlassian.com/software/confluence',
    imageUrl: 'https://logo.clearbit.com/atlassian.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'clickup',
    name: 'ClickUp',
    category: 'Collaboration',
    description: 'All-in-one productivity and project management platform',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['agency', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing', 'creative'],
    website: 'https://try.web.clickup.com/r2vvytndtmci',
    imageUrl: 'https://logo.clearbit.com/clickup.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'miro',
    name: 'Miro',
    category: 'Collaboration',
    description: 'Online collaborative whiteboarding platform for teams',
    pricing: ['medium', 'high'],
    features: ['ease-of-use', 'integrations', 'mobile', 'collaboration'],
    bestFor: ['startup', 'agency', 'small-business'],
    compatibleWith: ['agency', 'service-business', 'content-creator'],
    goals: ['streamline-operations', 'enhance-customer-service'],
    industries: ['technology', 'creative', 'marketing', 'education'],
    website: 'https://miro.com',
    imageUrl: 'https://logo.clearbit.com/miro.com',
    idealStages: ['launching', 'growing', 'scaling'],
    workEnvironments: ['remote', 'hybrid'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];